/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

export default function SEO({
  description = "",
  lang = "en",
  meta = [],
  title,
  image,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            image
            twitterUsername
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: `Zenduty | ${title}`,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        { name: `og:image`, content: site.siteMetadata.image },
        { name: `og:url`, content: site.siteMetadata.siteUrl },
        { name: `og:site_name`, content: title },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.twitterUsername,
        },
        {
          name: `twitter:title`,
          content: `Zenduty | ${title}`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image:src`,
          content:
            "https://d8x2313t22dpf.cloudfront.net/branding/cover/zendutybanner1-2.jpg",
        },
        {
          name: `image`,
          content: site.siteMetadata.image,
        },
        {
          name: `twitter:app:name:googleplay`,
          content: "Zenduty - Incident management for SRE and DevOps",
        },
        {
          name: `twitter:app:id:googleplay`,
          content: "com.yellowant.zenduty",
        },
      ].concat(meta)}
    />
  )
}
